module.exports = __webpack_public_path__ + "static/media/GIF.29d5e587.webm";